import { ViewportScroller } from '@angular/common';
import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { Router, Event, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-rekisteriseloste',
  standalone: true,
  imports: [MatCardModule, MatDividerModule],
  templateUrl: './rekisteriseloste.component.html',
  styleUrl: './rekisteriseloste.component.scss',
})
export class RekisteriselosteComponent {
  constructor(private router: Router) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }
}
